<style scoped lang="stylus">
    @import '../assets/css/theme.styl'
    .quick-time {
        .bt-box {
            text-align center
            button.van-button--default {
                background-color: baseConBackColor
                color: #fff
                border none
                &.cus-bt {
                    background-color: #6BA990
                }
            }
        }
    }
</style>

<template>
    <div class="quick-time">
        <div class="bt-box">
            <van-button v-for="(item, index) in timeList" :key="index" type="default" :class="isQuickTime && kType == item.key ? 'cus-bt' : ''" size="small" @click="timeChange(item)">{{item.name}}</van-button>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    export default {
        props: [
            'isQuickTime'
        ],
        components: {},
        data() {
            return {
                timeList: [
                    {
                        name: '当日',
                        key: 'day',
                    },
                    {
                        name: '昨日',
                        key: 'yesterday',
                    },
                    {
                        name: '前日',
                        key: 'before',
                    },
                    {
                        name: '本月',
                        key: 'month',
                    },
                    {
                        name: '上月',
                        key: 'preMonth',
                    },
                ],
                kType: 'day',
            };
        },
        created() {

        },
        mounted() {
            this.timeChange(this.timeList[0])
        },
        computed: {},
        watch: {},
        methods: {
            timeChange(data) {
                let time = []
                let formatStr = 'YYYY-MM-DD HH:mm:ss'
                this.kType = data.key
                switch (data.key) {
                    case 'day':
                        time.push(dayjs().startOf('day').format(formatStr))
                        time.push(dayjs().endOf('day').format(formatStr))
                        break;
                    case 'yesterday':
                        time.push(dayjs().subtract(1, 'day').startOf('day').format(formatStr))
                        time.push(dayjs().subtract(1, 'day').endOf('day').format(formatStr))
                        break;
                    case 'before':
                        time.push(dayjs().subtract(2, 'day').startOf('day').format(formatStr))
                        time.push(dayjs().subtract(2, 'day').endOf('day').format(formatStr))
                        break;
                    case 'month':
                        time.push(dayjs().startOf('month').format(formatStr))
                        time.push(dayjs().endOf('month').format(formatStr))
                        break;
                    case 'preMonth':
                        let monthDay = dayjs().subtract(1, 'month')
                        time.push(monthDay.startOf('month').format(formatStr))
                        time.push(monthDay.endOf('month').format(formatStr))
                        break;
                    default:
                        time.push(dayjs().startOf('day').format(formatStr))
                        time.push(dayjs().endOf('day').format(formatStr))
                        break;
                }
                time = _.join(time, ' - ')
                this.$emit('time-change', {time, type: data.key})
            }
        },
    };
</script>
